import React from 'react';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import DeductionPolicyForm from './DeductionPolicyForm';
import DeductionPolicyCreateApp from '../Functionality/DeductionPolicyCreateApp';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTitle: Full Stack Developer
 */
const DeductionPolicyCreate = ({ show, onHide, onSuccess }) => {
    const { t, item, setItem, emptyFields, isValidValue, isValidValueText, handleSubmit } = DeductionPolicyCreateApp({ show, onHide, onSuccess });

    return (
        <CustomModal
            show={show}
            title={t('create_deduction_policy')}
            buttonConfirm='create'
            onHide={onHide}
            onConfirm={handleSubmit}
        >
            <div className={"mt-2"}>
                <DeductionPolicyForm
                    item={item}
                    setItem={setItem}
                    emptyFields={emptyFields}
                    isValidValue={isValidValue}
                    isValidValueText={isValidValueText}
                />
            </div>
        </CustomModal>
    );
};

export default DeductionPolicyCreate;
